import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { server, tinyApiKey } from "../../server";
import axios from "axios";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import PageName from "../../Components/global/PageName";
import MyButton from "../../Components/global/MyButton";
import { Paper, TextField } from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";

export default function EditDoc() {
  const navigate = useNavigate();
  const [docDetails, setDocDetails] = useState("");
  const location = useLocation();
  const docId = location.state?.docId || null;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [category, setCategory] = useState("");
  const [changeSummary, setChangeSummary] = useState("");

  useEffect(() => {
    getDocumentDetails();
  }, []);

  const getDocumentDetails = async () => {
    try {
      if (!docId) return null;
      const { data } = await axios.get(`${server}/docs/getById`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          docsId: docId || null,
        },
      });

      setDocDetails(data?.data);

      // Set default values
      setTitle(data?.data?.title);
      setContent(data?.data?.content);
      setCategory(data?.data?.category);
    } catch (e) {
      toast.error(e?.response?.data || e.response);
    }
  };

  const handleUpdateDoc = async (data) => {
    try {
      const { data: resData } = await axios.patch(
        `${server}/docs/updateById`,
        content.toString() || "",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          params: {
            docsId: docId || null,
            title: title,
            coverImageUrl: "",
            changeSummary,
          },
        }
      );
      toast.success(resData?.message);
      reset();
      setContent("");
      navigate(-1);
    } catch (e) {
      toast.error(e?.response?.data?.message || e?.message);
    }
  };

  return (
    <div>
      <PageName title="Edit Document" />

      <Paper
        sx={{ p: 2, mt: 2, borderRadius: 2 }}
        className="border border-gray-300"
      >
        <div className="flex items-center justify-between border-b pb-5">
          <div className="text-xl font-semibold text-rose-600">
            Current Version : {docDetails.version}
          </div>

          <div className="text-xl font-semibold text-green-600">
            No. of Revisions : {docDetails.revisions?.length}
          </div>
        </div>

        <form
          onSubmit={handleSubmit(handleUpdateDoc)}
          className="mt-6 space-y-6"
        >
          {/* Document Title */}
          <div>
            <label>
              Document Title
              <input
                className="border w-full border-gray-300 p-3 rounded bg-gray-100 focus:bg-green-100 focus:outline-green-400"
                value={title}
                onChange={(e) => setTitle(e?.target?.value)}
              />
            </label>
          </div>
          {/* Blog Content - TinyMCE */}
          <Editor
            apiKey={tinyApiKey}
            init={{
              height: 600,
              menubar: true,
              plugins:
                "advlist autolink lists link image charmap print preview anchor " +
                "searchreplace visualblocks code fullscreen " +
                "insertdatetime media table paste code help wordcount",
              toolbar:
                "undo redo | formatselect | bold italic underline strikethrough | " +
                "alignleft aligncenter alignright alignjustify | " +
                "bullist numlist outdent indent | " +
                "link image media table | " +
                "forecolor backcolor removeformat | " +
                "charmap fullscreen preview code help",
              image_advtab: true,
              content_style:
                "body { font-family:Arial, sans-serif; font-size:14px }",
            }}
            value={content}
            onEditorChange={(content) => setContent(content)}
          />

          {errors.content && (
            <p className="text-red-500 text-sm">{errors.content.message}</p>
          )}

          {/* Document Category */}
          <div>
            <label className="">
              Document Category
              <input
                className="border w-full border-gray-300 p-3 rounded bg-gray-100 focus:bg-green-100 focus:outline-green-400"
                value={category}
                onChange={(e) => setCategory(e?.target?.value)}
              />
            </label>
          </div>

          {/* Document Category */}
          <div>
            <label className="">
              Change Summary
              <input
                className="border w-full border-gray-300 p-3 rounded bg-gray-100 focus:bg-green-100 focus:outline-green-400"
                value={changeSummary}
                onChange={(e) => setChangeSummary(e?.target?.value)}
              />
            </label>
          </div>

          {/* Buttons */}
          <div className="flex items-center justify-end gap-6">
            <MyButton
              variant="outline"
              type="button"
              onClick={() => navigate(-1)}
            >
              CANCEL
            </MyButton>

            <MyButton type="submit">UPDATE</MyButton>
          </div>
        </form>
      </Paper>
    </div>
  );
}
